// What "no data" means for a provider, defined once for the scorecard, the provider drawer, Search
// Lift and Multi-turn Decay. The backend marks a provider whose collection failed for a run with
// `data_status: 'collection_failed'` and null rates — those rows must read as unmeasured, never 0%.
// A provider that answered only some of its calls is `partial`; `ok` is the rest.

/** The one-line explanation shown wherever a failed provider would otherwise show numbers. */
export const NO_DATA_MESSAGE = 'No data from this provider for this run — already with our team.';

/**
 * Did collection fail for this scorecard, coverage, Search Lift or P11 row?
 *
 * @param {{data_status?: string}|null|undefined} row
 * @returns {boolean}
 */
export const isCollectionFailed = (row) => row?.data_status === 'collection_failed';

/** The note shown where a provider answered some, but not all, of its calls. */
export const PARTIAL_DATA_MESSAGE = 'Some answers from this provider failed — figures use the answered calls only.';

/**
 * Did the provider answer only some of its calls for this row?
 *
 * Rates on a partial row are computed from the answered calls and are drawn as returned.
 *
 * @param {{data_status?: string}|null|undefined} row a Search Lift or P11 row
 * @returns {boolean}
 */
export const isPartial = (row) => row?.data_status === 'partial';

/**
 * Which search modes of a Search Lift row have no data for the run.
 *
 * Search Lift is keyed by family (`openai`) and carries a status for each mode; a failed mode has
 * a null rate.
 *
 * @param {{search_on_status?: string, search_off_status?: string}|null|undefined} row a Search Lift row
 * @returns {{on: boolean, off: boolean}} true for a mode whose collection failed
 */
export function searchLiftModes(row) {
  return {
    on: row?.search_on_status === 'collection_failed',
    off: row?.search_off_status === 'collection_failed',
  };
}
